import { Components } from '@mui/material/styles/components';

export const SvgIconComponent: Components = {
  MuiSvgIcon: {
    defaultProps: {
      fontSize: 'small',
    },
    styleOverrides: {
      root: {
        fontSize: '1.25rem',
      },
      fontSizeLarge: {
        fontSize: '1.5rem',
      },
      fontSizeSmall: {
        fontSize: '1rem',
      },
    },
  },
};
